<template>
  <form
    style="display: none"
    ref="postForm"
    :action="`${
      action.slice(-1) == '/' ? action.slice(0, action.length - 1) : action
    }/adb2c.html`"
    methods="POST"
  >
    <input type="text" name="identifier" :value="nameIdentifier" id="id" />
    <input type="text" name="cmd" :value="cmd" id="cmd" />
    <button type="submit" ref="submitBtn">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    action: String,
    nameIdentifier: String,
    cmd: String,
  },
  mounted() {
    this.$emit("emitRefs", this.$refs.submitBtn);
  },
  methods: {},
};
</script>

<style>
</style>